import { render, staticRenderFns } from "./_base-select.vue?vue&type=template&id=47bd6d0e&scoped=true&"
import script from "./_base-select.vue?vue&type=script&lang=js&"
export * from "./_base-select.vue?vue&type=script&lang=js&"
import style0 from "./_base-select.vue?vue&type=style&index=0&id=47bd6d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd6d0e",
  null
  
)

export default component.exports